// 路由配置文件
import Vue from 'vue';
import Router from 'vue-router';

// import EssentialContainer from '@components/others/EssentialContainer';
import _import from './_import';

// import moduleRouters from './modules';

Vue.use(Router);

// 路由
const initRouterMap = [
  {
    path: '/',
    component: _import('testActivity'),
    meta: {
      title: '抽奖活动'
    }
  }
];

// 补全路由
function completeRouter(router, subRouter) {
  if (!router) {
    return;
  }
  let component = router.component;

  // 默认填充空路由页面
  if (!component && subRouter) {
    // component = EssentialContainer;
  }

  if (typeof component === 'string') {
    component = _import(component);
  }

  return {
    meta: {},
    ...router,
    component,
    children: router.children && router.children.map(v => completeRouter(v, true))
  };
}

// TODO 异步路由
// const asyncRouter = moduleRouters.map(v => completeRouter(v));

export const routerMap = {
  constantRouter: initRouterMap.map(v => completeRouter(v)),
  asyncRouter: []
};

const router = new Router({
  routes: routerMap.constantRouter,
  scrollBehavior() {
    return {x: 0, y: 0};
  }
});

// console.log(routerMap.constantRouter);

router.beforeEach(async(to, from, next) => {
  // 非登录页面
  if (!['/logout'].includes(to.path)) {
    // 只需要进行一次的公共请求可以放在这里

    // TODO 从请求获取权限列表时生成路由
    // console.log(asyncRouter);

  }
  // 未匹配到到路径则跳转至首页
  // TODO 配置路由
  if (to.matched.length === 0) {
    return next('/activity'); // 如果未匹配到路由
  }

  // 标题
  if (to.meta?.title) {
    document.title = to.meta.title;
  }

  return next();
});

export default router;
